import {
  type Course,
  CourseIntake,
  type CourseSegment,
  type PublicCourseSegment,
} from 'types/course'

type CourseDetailsOutlineProps = {
  courseSegments: PublicCourseSegment[] | CourseSegment[]
}

export default function CourseDetailsOutline({
  courseSegments,
}: CourseDetailsOutlineProps) {
  return (
    <div className='flex flex-col gap-6'>
      {courseSegments?.map((segment) => (
        <div
          key={segment.id}
          className='p-6 rounded-xl border border-mischka flex-col gap-4 flex'
        >
          <div className='font-heading text-lg font-semibold leading-none'>
            {segment.title}
          </div>
          <ol className='text-base font-medium leading-loose list-decimal list-inside text-comet'>
            {segment.courseSections.map((section) => (
              <li key={section.id}>{section.title}</li>
            ))}
          </ol>
        </div>
      ))}
    </div>
  )
}
